import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getDarkModePreference } from "../utils/domUtils";
import { hexToCSSRGBa } from "../utils/stringUtils";
export var codesandboxLightTheme = {
  palette: {
    activeText: "#1f2933",
    defaultText: "#757678",
    inactiveText: "#e4e7eb",
    activeBackground: "#e4e7eb",
    defaultBackground: "#f8f9fb",
    inputBackground: "#ffffff",
    accent: "#64D2FF",
    errorBackground: "#ffcdca",
    errorForeground: "#811e18"
  },
  syntax: {
    plain: "#151515",
    comment: {
      color: "#999",
      fontStyle: "italic"
    },
    keyword: "#0971F1",
    tag: "#0971F1",
    punctuation: "#151515",
    definition: "#151515",
    property: "#151515",
    static: "#FF453A",
    string: "#BF5AF2"
  },
  typography: {
    bodyFont: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    monoFont: '"Fira Mono", "DejaVu Sans Mono", Menlo, Consolas, "Liberation Mono", Monaco, "Lucida Console", monospace',
    fontSize: "14px"
  }
};
export var aquaBlueTheme = {
  palette: {
    activeText: "#1f2933",
    defaultText: "#737373",
    inactiveText: "#e4e7eb",
    activeBackground: "#e4e7eb",
    defaultBackground: "#f8f9fb",
    inputBackground: "#ffffff",
    accent: "#6caedd",
    errorBackground: "#ffcdca",
    errorForeground: "#811e18"
  },
  syntax: {
    plain: "#1F2933",
    comment: {
      color: "#A7B6C2",
      fontStyle: "italic"
    },
    keyword: "#1A56DB",
    tag: "#1A56DB",
    punctuation: "#394b59",
    definition: "#A23DAD",
    property: "#14919B",
    static: "#1A56DB",
    string: "#1992D4"
  },
  typography: {
    bodyFont: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    monoFont: '"Fira Mono", "DejaVu Sans Mono", Menlo, Consolas, "Liberation Mono", Monaco, "Lucida Console", monospace',
    fontSize: "14px"
  }
};
export var codesandboxDarkTheme = {
  palette: {
    activeText: "#FFFFFF",
    defaultText: "#999999",
    inactiveText: "#343434",
    activeBackground: "#343434",
    defaultBackground: "#040404",
    inputBackground: "#242424",
    accent: "#6caedd",
    errorBackground: "#ffcdca",
    errorForeground: "#811e18"
  },
  syntax: {
    plain: "#FFFFFF",
    comment: {
      color: "#757575",
      fontStyle: "italic"
    },
    keyword: "#77B7D7",
    tag: "#DFAB5C",
    punctuation: "#ffffff",
    definition: "#86D9CA",
    property: "#77B7D7",
    static: "#C64640",
    string: "#977CDC"
  },
  typography: {
    bodyFont: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    monoFont: '"Fira Mono", "DejaVu Sans Mono", Menlo, Consolas, "Liberation Mono", Monaco, "Lucida Console", monospace',
    fontSize: "14px"
  }
};
export var nightOwlTheme = {
  palette: {
    activeText: "rgb(197, 228, 253)",
    defaultText: "rgb(105, 136, 161)",
    inactiveText: "rgb(78, 82, 97)",
    activeBackground: "rgb(58, 62, 77)",
    defaultBackground: "rgb(1, 22, 39)",
    inputBackground: "rgb(11, 41, 66)",
    accent: "#7fdbca",
    errorBackground: "#ffcdca",
    errorForeground: "#811e18"
  },
  syntax: {
    plain: "#d6deeb",
    comment: {
      color: "#999999",
      fontStyle: "italic"
    },
    keyword: {
      color: "#c792ea",
      fontStyle: "italic"
    },
    tag: "#7fdbca",
    punctuation: "#7fdbca",
    definition: "#82aaff",
    property: {
      color: "#addb67",
      fontStyle: "italic"
    },
    static: "#f78c6c",
    string: "#ecc48d"
  },
  typography: {
    bodyFont: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    monoFont: '"Fira Mono", "DejaVu Sans Mono", Menlo, Consolas, "Liberation Mono", Monaco, "Lucida Console", monospace',
    fontSize: "14px"
  }
};
export var monokaiProTheme = {
  palette: {
    activeText: "rgb(252, 252, 250)",
    defaultText: "rgb(147, 146, 147)",
    inactiveText: "#444344",
    activeBackground: "#444344",
    defaultBackground: "rgb(45, 42, 46)",
    inputBackground: "rgb(25, 24, 26)",
    accent: "rgb(255, 216, 102)",
    errorBackground: "#ffcdca",
    errorForeground: "#811e18"
  },
  syntax: {
    plain: "rgb(252, 252, 250)",
    comment: {
      color: "#757575",
      fontStyle: "italic"
    },
    keyword: "rgb(255, 97, 136)",
    tag: "rgb(120, 220, 232)",
    punctuation: "rgb(147, 146, 147)",
    definition: "rgb(169, 220, 118)",
    property: {
      color: "rgb(120, 220, 232)",
      fontStyle: "italic"
    },
    static: "rgb(171, 157, 242)",
    string: "rgb(255, 216, 102)"
  },
  typography: {
    bodyFont: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    monoFont: '"Fira Mono", "DejaVu Sans Mono", Menlo, Consolas, "Liberation Mono", Monaco, "Lucida Console", monospace',
    fontSize: "14px"
  }
};
export var SANDPACK_THEMES = {
  "codesandbox-light": codesandboxLightTheme,
  "codesandbox-dark": codesandboxDarkTheme,
  "night-owl": nightOwlTheme,
  "aqua-blue": aquaBlueTheme,
  "monokai-pro": monokaiProTheme
};
export var createThemeObject = function createThemeObject(inputTheme) {
  var defaultLightTheme = codesandboxLightTheme;
  var defaultLightThemeKey = "codesandbox-light";
  var defaultDarkTheme = codesandboxDarkTheme;
  var defaultDarkThemeKey = "codesandbox-dark";

  if (inputTheme === undefined) {
    return {
      theme: defaultLightTheme,
      id: defaultLightThemeKey
    };
  }

  if (inputTheme === "auto") {
    return getDarkModePreference() ? {
      theme: defaultDarkTheme,
      id: defaultDarkThemeKey
    } : {
      theme: defaultLightTheme,
      id: defaultLightThemeKey
    };
  }

  if (typeof inputTheme === "string") {
    var predefinedTheme = SANDPACK_THEMES[inputTheme];

    if (!predefinedTheme) {
      throw new Error("Invalid theme '".concat(inputTheme, "' provided."));
    }

    return {
      theme: predefinedTheme,
      id: inputTheme !== null && inputTheme !== void 0 ? inputTheme : defaultLightThemeKey
    };
  }

  var theme = {
    palette: _objectSpread(_objectSpread({}, defaultLightTheme.palette), inputTheme === null || inputTheme === void 0 ? void 0 : inputTheme.palette),
    syntax: _objectSpread(_objectSpread({}, defaultLightTheme.syntax), inputTheme === null || inputTheme === void 0 ? void 0 : inputTheme.syntax),
    typography: _objectSpread(_objectSpread({}, defaultLightTheme.typography), inputTheme === null || inputTheme === void 0 ? void 0 : inputTheme.typography)
  };
  var id = simpleHashFunction(JSON.stringify(theme));
  return {
    theme: theme,
    id: "sp-".concat(id)
  };
};

var simpleHashFunction = function simpleHashFunction(str) {
  var hash = 0;

  for (var i = 0; i < str.length; hash &= hash) {
    hash = 31 * hash + str.charCodeAt(i++);
  }

  return Math.abs(hash);
}; // inactive fg and active bg are interchangable to limit the number of colors in the theme
// bg-default-overlay is determined by adjusting the alpha channel on the default bg to 80%


export var getThemeStyleSheet = function getThemeStyleSheet(theme, themeId) {
  return "\n.sp-wrapper.sp-".concat(themeId, " {\n  --sp-colors-fg-active: ").concat(theme.palette.activeText, ";\n  --sp-colors-fg-default: ").concat(theme.palette.defaultText, ";\n  --sp-colors-fg-inactive: ").concat(theme.palette.inactiveText || theme.palette.activeBackground, ";\n  --sp-colors-bg-active: ").concat(theme.palette.activeBackground || theme.palette.inactiveText, ";\n  --sp-colors-bg-default: ").concat(theme.palette.defaultBackground, ";\n  --sp-colors-bg-default-overlay: ").concat(hexToCSSRGBa(theme.palette.defaultBackground, 0.8), ";\n  --sp-colors-bg-input: ").concat(theme.palette.inputBackground, ";\n  --sp-colors-accent: ").concat(theme.palette.accent, ";\n  --sp-colors-bg-error: ").concat(theme.palette.errorBackground, ";\n  --sp-colors-fg-error: ").concat(theme.palette.errorForeground, ";\n  --sp-font-size: ").concat(theme.typography.fontSize, ";\n  --sp-font-body: ").concat(theme.typography.bodyFont, ";\n  --sp-font-mono: ").concat(theme.typography.monoFont, ";\n");
};
export var getSyntaxStyle = function getSyntaxStyle(token) {
  if (typeof token === "string") {
    return {
      color: token
    };
  }

  return token;
};